import React, { useCallback, useEffect, useRef } from 'react';
import KendoReactColorPicker from '@Shared.Angular/kendo.react/KendoReactColorPicker';
import {
  toggleColorPickerPopup,
  POPUP_CLASSES
} from '@Shared.Angular/kendo.react/KendoReactColorPickerUtils';
import IconButton from '@Shared.Angular/flowingly.components/buttons/IconButton';

type Props = {
  value: string;
  onColorChange: (color: string) => void;
};

export default function ColorPicker({ value, onColorChange }: Props) {
  const timeoutRef = useRef<number | null>(null);
  const kendoButtonRef = useRef<HTMLButtonElement | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const updateColor = (hexCode: string): void => {
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(() => {
      if (!hexCode) return;
      const hexColor = '#' + hexCode;
      onColorChange(hexColor);
    }, 200);
  };

  useEffect(() => {
    if (containerRef.current) {
      const kendoContainer = containerRef.current.querySelector(
        '.kendo-react-color-picker'
      );
      if (kendoContainer) {
        const button = kendoContainer.querySelector(
          'button.k-input-button'
        ) as HTMLButtonElement;
        if (button) {
          kendoButtonRef.current = button;
        }
      }
    }

    return () => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const toggleColorPicker = useCallback(() => {
    toggleColorPickerPopup(kendoButtonRef.current, POPUP_CLASSES.COLOR_PICKER);
  }, []);

  return (
    <div className="color-picker-custom-container" ref={containerRef}>
      <div
        className="color-preview-swatch"
        style={{ backgroundColor: value }}
      ></div>
      <IconButton
        classNames="color-picker-edit-button"
        iconClass="fa-pencil"
        title="Change colour"
        onClick={toggleColorPicker}
        border={false}
      />
      <KendoReactColorPicker
        gradientSettings={{ opacity: false }}
        views={['gradient']}
        flatColorPickerSettings={{
          format: 'hex',
          showButtons: false,
          showPreview: false,
          showClearButton: false,
          views: ['gradient'],
          onPreviewChange: updateColor
        }}
        popupSettings={{
          className: 'form-theme-custom-color-picker'
        }}
        value={value}
      />
    </div>
  );
}
